import React, { useState } from 'react';
import Button from 'components/common/Button';
import style from './style.scss';

import Proptypes from 'prop-types';

const SearchBar = ({ onSearch, initialValue = '' }) => {
  const [searchTerm, setSearchTerm] = useState(initialValue);

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSearch(searchTerm);
  };

  return (
    <form className="search-bar" onSubmit={handleSubmit}>
      <input
        className="input is-rounded search-input"
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleInputChange}
      />
      <Button rounded type="submit">Search</Button>
    </form>
  );

};

SearchBar.propTypes = {
  onSearch: Proptypes.func,
  initialValue: Proptypes.string
};

export default SearchBar;